import { useQueryClient, queryOptions } from '@tanstack/react-query';
import { ProductMatrixGetProductsRequest } from 'bff/client';
import { clientService } from 'stores/client-store/client-store';

export const useInvalidateProductOptions = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['get-product-options']
    });
};

export const getProductOptions = (productSelectionRequest: ProductMatrixGetProductsRequest) => {
  const { productMatrixApi } = clientService.getApiClient();

  return queryOptions({
    queryKey: ['get-product-options', productSelectionRequest],
    queryFn: () => productMatrixApi.productMatrixGetProducts(productSelectionRequest),
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
    select: (response) => response.data!
  });
};
